export type ShouldShowPremiumBannerOptions = {
  allowed: boolean;
  enforced: boolean;
  limit: number;
  total: number;
};

export const shouldShowPremiumBanner = ({
  allowed,
  enforced,
  limit,
  total,
}: ShouldShowPremiumBannerOptions): boolean =>
  !allowed || (!enforced && limit < total);
